import * as React from "react";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Badge, Col, Row } from "components/bootstrap";
import { DocumentTitle, PageHeader } from "components/common";
import PaginatedEntityTable from "components/common/PaginatedEntityTable";
import { formatReadableNumber } from "util/NumberFormatting";
import AIFeaturesStatusAlerts from "ai-management/components/AIFeaturesStatusAlerts";
import { DEFAULT_LAYOUT } from "./AgentWorkflowRuns/Constants";
import fetchAgentWorkflowRuns from "./AgentWorkflowRuns/fetchAgentWorkflowRuns";
import fetchWorkflowRunSlices from "./AgentWorkflowRuns/fetchWorkflowRunSlices";
import customColumnRenderers from "./AgentWorkflowRuns/ColumnRenderers";
import expandedSections from "./AgentWorkflowRuns/expandedSections";
import AgentWorkflowPageNavigation from "./AgentWorkflowPageNavigation";
const KEY_PREFIX = ["aiagent", "workflow-runs"];
const keyFn = (searchParams) => [...KEY_PREFIX, searchParams];
const AgentWorkflowRunsPage = () => {
  const { t } = useTranslation("enterprise_ai");
  const sliceRenderers = useMemo(
    () => ({
      type: {
        renderAdditional: (slice) => {
          var _a, _b;
          const headsUp = (_b = (_a = slice.meta) == null ? void 0 : _a.headsUpCount) != null ? _b : 0;
          return /* @__PURE__ */ React.createElement(React.Fragment, null, headsUp > 0 && /* @__PURE__ */ React.createElement(Badge, { bsStyle: "warning" }, formatReadableNumber(headsUp)), /* @__PURE__ */ React.createElement(Badge, null, formatReadableNumber(slice.count)));
        }
      }
    }),
    []
  );
  return /* @__PURE__ */ React.createElement(DocumentTitle, { title: t("run_list_page.document_title") }, /* @__PURE__ */ React.createElement(AgentWorkflowPageNavigation, null), /* @__PURE__ */ React.createElement(PageHeader, { title: t("run_list_page.title") }, /* @__PURE__ */ React.createElement("span", null, t("run_list_page.description"))), /* @__PURE__ */ React.createElement(AIFeaturesStatusAlerts, null), /* @__PURE__ */ React.createElement(Row, { className: "content" }, /* @__PURE__ */ React.createElement(Col, { md: 12 }, /* @__PURE__ */ React.createElement(
    PaginatedEntityTable,
    {
      humanName: t("run_list_page.human_name"),
      tableLayout: DEFAULT_LAYOUT,
      fetchEntities: fetchAgentWorkflowRuns,
      fetchSlices: fetchWorkflowRunSlices,
      sliceRenderers,
      fetchOptions: { refetchInterval: 5e3 },
      keyFn,
      columnRenderers: customColumnRenderers,
      expandedSectionRenderers: expandedSections,
      entityAttributesAreCamelCase: false
    }
  ))));
};
export default AgentWorkflowRunsPage;
